<template>
  <!-- BEGIN: Library Folder Selector Modal -->
  <div id="library-folder-selector-modal" class="modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="font-medium text-base mr-auto">
            選擇資料夾
          </h2>
        </div>
        <div class="modal-body p-0">
          <library-page :auth="auth" :current-site="currentSite" :permissions="permissions" :modal-folder-code="folderCode" :modalFolder="true" :currentSelectedItem="selectedItem" :modalFolderWriteOnly="modalFolderWriteOnly" @select="onSelectFolder" ref="libraryPage"></library-page>
          <div class="px-5 pb-8 text-center mt-4">
            <button type="button" data-tw-dismiss="modal" class="btn btn-outline-secondary w-24 mr-1">關閉</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END: Library Modal -->
</template>

<script>
import LibraryPage from '@/page/library/LibraryPage.vue'

export default {
  components: { LibraryPage },
  props: ['auth', 'currentSite', 'permissions', 'modalFolderWriteOnly'],
  data() {
    return {
      folderCode: null,
      selectedItem: null
    }
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    onShow(folderCode = null, selectedItem = null) {
      const oldFolderCode = this.folderCode

      this.folderCode = folderCode
      this.selectedItem = selectedItem

      if (oldFolderCode === folderCode) {
        this.$refs.libraryPage.loadLibraryItems(true)
      }

      const el = document.querySelector('#library-folder-selector-modal')
      const modal = window.tailwind.Modal.getOrCreateInstance(el)
      modal.show()
    },
    onSelectFolder(item) {
      this.$emit('on-select', item)

      const el = document.querySelector('#library-folder-selector-modal')
      const modal = window.tailwind.Modal.getOrCreateInstance(el)
      modal.hide()
    }
  }
}
</script>
<style lang="scss" scoped>
#library-folder-selector-modal {
}
</style>
